import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  BrowserRouter,
} from "react-router-dom";
import Sidebar from "./components/Sidebar";
import Navbar from "./components/Navbar";
import Signin from "./pages/auth/Signin";
import Shayari from "./components/ShayariMaster/Shayari";
import AddUser from "./pages/home/AddUser";
import Home from "./components/Home";
import Shayars from "./components/ShayariMaster/Shayars";
import Students from "./pages/Students";
import Lessons from "./pages/home/Lessons";
import ImportShayari from "./components/ShayariMaster/ImportShayari";
import ImportLesson from "./components/ImportLesson";
import LocalData from "./models/LocalData";
import Vocabulary from "./components/Vocabulary";
import VocabularyCatMaster from "./components/VocabularyCatMaster";
import ImportVocabulary from "./components/ImportVocabulary";
import SendNotification from "./components/SendNotification";
import UserChats from "./components/UserChats";
import Setting from "./components/Setting";



function App() {
  let auth_data = LocalData.getLoggedInfo();
  auth_data = auth_data ? JSON.parse(auth_data) : null;

  const [signin_info, setsignininfo] = useState(auth_data);

  if (!signin_info) {
    return (
      <BrowserRouter>
        <Routes>
          <Route
            path="/admin"
            element={<Signin setsignininfo={setsignininfo} />}
          />
        </Routes>
      </BrowserRouter>
    );
  }

  const Layout = ({ children, toggleSidebar, sidebarOpen }) => (
    <div className="flex h-screen bg-cream-50 overflow-hidden">
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      <div
        className={`flex-1 flex flex-col overflow-hidden duration-300 ${sidebarOpen ? "ml-60" : "ml-12"
          }`}
      >
        <Navbar toggleSidebar={toggleSidebar} />
        <main className="flex-1 overflow-y-auto p-4 md:p-6 bg-[--bg-color]">
          {children}
        </main>
      </div>
    </div>
  );

  const AppRoutes = () => {
    const location = useLocation();
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [ismanualToggle, setIsManualToggle] = useState(false);

    const toggleSidebar = () => {
      setSidebarOpen((prev) => !prev);
      setIsManualToggle(true); // user toggled manually
    };

    useEffect(() => {
      const handleResize = () => {
        if (window.innerWidth <= 900 && !ismanualToggle) {
          setSidebarOpen(false);
        } else if (window.innerWidth > 900 && !ismanualToggle) {
          setSidebarOpen(true);
        }
      };

      handleResize();
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, [ismanualToggle]);

    // if (!signin_info) {
    //   return (
    //     <BrowserRouter>
    //       <Routes>
    //         <Route path="/" element={<Signin setsignininfo={setsignininfo} />} />
    //       </Routes>
    //     </BrowserRouter>
    //   );
    // }

    return (
      <Layout toggleSidebar={toggleSidebar} sidebarOpen={sidebarOpen}>
        <Routes>
          <Route path="/admin" element={<Home />} />
          <Route path="shayars" element={<Shayars />} />
          <Route path="shayari" element={<Shayari />} />
          <Route path="importshayari" element={<ImportShayari />} />
          <Route path="adduser" element={<AddUser />} />
          <Route path="students" element={<Students />} />
          <Route path="lessons" element={<Lessons />} />
          <Route path="importlesson" element={<ImportLesson />} />
          <Route path="vocabulary" element={<Vocabulary />} />
          <Route path="vocabularycategory" element={<VocabularyCatMaster />} />
          <Route path="importvocabulary" element={<ImportVocabulary />} />
          <Route path="sendnotification" element={< SendNotification />} />
          <Route path="userchats" element={< UserChats />} />
          <Route path="settings" element={< Setting />} />
        </Routes>
      </Layout>
    );
  };

  return (
    <Router>
      {!signin_info ? (
        <Routes>
          <Route
            path="/admin"
            element={<Signin setsignininfo={setsignininfo} />}
          />
        </Routes>
      ) : (
        <AppRoutes />
      )}
    </Router>
  );
}

export default App;

// if we can signin successfully return to home page path show dashboard
